import React from "react";
import styles from "./allExpense.module.css";
import { Home } from "react-feather";
import Helmet from "react-helmet";
import Footer from "../../../components/Footer";
import Loader from "../../../components/Loader";
import { Typography } from "@mui/material";
import ExpenseList from "./components/expense-list/ExpenseList";
import withCustomAuthenticationRequired from "../../../auth/withCustomAuthenticationRequired";

const AllExpense = () => {
  return (<React.Fragment>
    <Helmet title="Income" />

    <div className={`${styles.pageTitleWrap}`}>
      <Typography display="inline" className={`${styles.pageTitle}`}>Expense</Typography>
      <nav aria-label="breadcrumb">
        <ol className={`${styles.breadcrumb}`}>
          <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Expense</li>
          <li className={`${styles.breadcrumbItem} ${styles.active}`}>All Expense</li>
        </ol>
      </nav>
    </div>

    <div>
      <ExpenseList />
    </div>

    <Footer />
  </React.Fragment>);
};

export default withCustomAuthenticationRequired(AllExpense, {
  onRedirecting: () => <Loader />,
});